import settings from '@/constants/constants';
import { Logger } from '@/utils/logger';
import { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import { Alert, Link, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';

const logger = new Logger('ShippingOptionAlertValidId');

type AlertConfig = {
  alertText: string;
  linkText?: string;
  helpLink: string;
};

const ALERT_CONFIG: Partial<Record<(typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'], AlertConfig>> = {
  [DELIVERY_OPTIONS[DELIVERY_OPTION.SameDayAfternoon].name]: {
    alertText: 'You must receive the order in-person and present a valid ID. ',
    linkText: 'Learn more',
    helpLink: `${settings.support.site.url}/articles/14664095252751-Receiving-your-This-afternoon-delivery`,
  },
  [DELIVERY_OPTIONS[DELIVERY_OPTION.ClickAndCollect].name]: {
    alertText: 'You must collect the order in-person and present a valid ID. ',
    linkText: 'Learn more',
    helpLink: `${settings.support.site.url}/articles/15139942467855-Click-Collect-Process`,
  },
};

export const ShippingOptionAlertValidId = ({
  deliveryOptionName,
}: {
  deliveryOptionName: (typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'];
}) => {
  const config = ALERT_CONFIG[deliveryOptionName];
  const { alertText, linkText, helpLink } = config || {};

  useEffect(() => {
    if (!helpLink) {
      logger.critical('missing helpLink', {
        deliveryOptionName,
      });
    }
  }, [deliveryOptionName, helpLink]);

  return (
    <Alert severity="warning" data-testid="shippingOptionAlertValidId">
      <Typography variant="body2">
        {alertText}
        {helpLink && (
          <Link id="shipping_valid_id_banner_help_link" href={helpLink} target="_blank" rel="noopener noreferrer">
            {linkText}
          </Link>
        )}
        .
      </Typography>
    </Alert>
  );
};
